import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Input } from "@/components/ui/input";
import { CheckCircle2, ExternalLink } from "lucide-react";
import api from "@/lib/api";
import { ConfirmDelete } from "@/components/admin/ConfirmDelete";

const match = (l, q) => [l.name, l.business_name, l.email, l.phone, l.website_url].some(v => (v || "").toLowerCase().includes(q));

export const AdminLeadsTab = () => {
  const [leads, setLeads] = useState(null);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/api/webadvisor/leads").then(r => setLeads(r.data)).catch(() => setLeads([])); }, []);
  const shown = (leads || []).filter(l => !q || match(l, q.toLowerCase()));

  return (
    <div className="bg-white border border-slate-200 rounded-xl p-6 shadow-sm overflow-x-auto" data-testid="admin-leads-tab">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 mb-4">
        <div>
          <h2 className="text-lg font-semibold text-slate-900">Web Advisor Leads</h2>
          <p className="text-xs text-slate-500">Every scanned prospect. Customers also appear under Clients.</p>
        </div>
        <Input placeholder="Search name, business, email…" value={q} onChange={e => setQ(e.target.value)} className="sm:w-72 border-slate-300" data-testid="admin-leads-search" />
      </div>
      <Table>
        <TableHeader><TableRow className="border-slate-200"><TableHead>Prospect</TableHead><TableHead>Email</TableHead><TableHead>Phone</TableHead><TableHead>Stage</TableHead><TableHead>Rep</TableHead><TableHead /></TableRow></TableHeader>
        <TableBody>
          {shown.map(l => (
            <TableRow key={l.id} className="border-slate-100" data-testid={`admin-lead-row-${l.id}`}>
              <TableCell>
                <div className="font-medium text-slate-900">{l.business_name || l.website_url}</div>
                <div className="text-xs text-slate-500">{l.name}</div>
              </TableCell>
              <TableCell className="text-sm text-slate-600">{l.email || "-"}</TableCell>
              <TableCell className="text-sm text-slate-600">{l.phone || "-"}</TableCell>
              <TableCell>
                <span className="text-xs px-2 py-1 rounded-full bg-slate-100 text-slate-700">{l.status}</span>
                {l.customer_user_id && <span className="ml-1 inline-flex items-center gap-1 text-xs px-2 py-1 rounded-full bg-green-50 text-green-700" data-testid={`admin-lead-customer-${l.id}`}><CheckCircle2 className="w-3 h-3" />Customer</span>}
              </TableCell>
              <TableCell className="text-sm text-slate-600">{l.assigned_name || "Unassigned"}</TableCell>
              <TableCell>
                <Link to={`/webadvisor/leads/${l.id}`} className="inline-flex items-center gap-1 text-xs font-medium text-blue-600 hover:underline" data-testid={`admin-lead-open-${l.id}`}>Open <ExternalLink className="w-3 h-3" /></Link>
                <ConfirmDelete url={`/api/webadvisor/leads/${l.id}`} title="Delete this lead?" description="Removes the lead with its audits, plans, invoices, payments, landing pages and shared reports." onDone={() => setLeads(ls => ls.filter(x => x.id !== l.id))} testId={`admin-lead-delete-${l.id}`} className="ml-2" />
              </TableCell>
            </TableRow>
          ))}
          {leads !== null && shown.length === 0 && <TableRow><TableCell colSpan={6} className="text-center text-slate-400 py-8" data-testid="admin-leads-empty">No leads</TableCell></TableRow>}
        </TableBody>
      </Table>
    </div>
  );
};
